


















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Sticky, Popup, Toast } from 'vant';
import SearchBar from '../components/SearchBar.vue';
import ListItem from '../components/ListItem.vue';
import { getList, getBaseInfo } from '../api';

Vue.use(List)
  .use(Sticky)
  .use(Popup);

@Component({
  components: {
    SearchBar,
    ListItem,
  },
})
export default class Home extends Vue {
  show: boolean = true;
  keyword = '';
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  page = 1;
  searchTimer: any = null;
  list: any[] = [];
  baseInfo: any = {};
  selectIndex: number = 0;
  value: string = '';
  showEmptyimg: boolean = true;
  showempty: boolean = false;
  canvote: boolean = true;
  inway: number = 1;
  // votetimelist: any = {
  //   //投票时间
  //   voteysstr: 1688598000000, //2023-07-06 07:00:00
  //   // voteysend: 1689156000000, //2023-07-12 18:00:00
  //   voteysend: 1689177600000, //2023-07-13 00:00:00
  //   votecsstr: 1691078400000, //2023-08-04 00:00:00
  //   votecsend: 1691661600000, //2023-08-10 18:00:00
  //   votejsstr: 1693065600000, //2023-08-27 00:00:00
  //   votejsend: 1693389600000, //2023-08-30 18:00:00
  // };
  votetimelist: any = {
    //投票时间
    voteysstr: 1688598000000, //2023-07-06 07:00:00
    // voteysend: 1689156000000, //2023-07-12 18:00:00
    voteysend: 1689177600000, //2023-07-13 00:00:00
    votecsstr: 1690214400000, //2023-07-25 00:00:00
    votecsend: 1691337600000, //2023-08-07 00:00:00
    votejsstr: 1691510400000, //2023-08-09 00:00:00
    votejsend: 1692720000000, //2023-08-23 00:00:00
  };
  // showtimelist: any = {
  //   //展示时间
  //   showysstr: 1688598000000, //2023-07-06 07:00:00
  //   showysend: 1691078400000, //2023-08-04 00:00:00
  //   showcsstr: 1691078400000, //2023-08-04 00:00:00
  //   showcsend: 1693065600000, //2023-08-27 00:00:00
  //   showjsstr: 1693065600000, //2023-08-27 00:00:00
  //   showjsend: 1693389600000, //2023-08-30 18:00:00
  // };
  showtimelist: any = {
    //展示时间
    showysstr: 1688598000000, //2023-07-06 07:00:00
    showysend: 1690214400000, //2023-07-25 00:00:00
    showcsstr: 1690214400000, //2023-07-25 00:00:00
    showcsend: 1691510400000, //2023-08-09 00:00:00
    showjsstr: 1691510400000, //2023-08-09 00:00:00
    showjsend: 1696089600000, //2023-10-01 00:00:00
  };
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    this.getinway();
    this.getvotetime();
    // this.onLoad();
  }
  getinway() {
    const nowtime = parseInt(new Date().getTime() + '');
    // console.log('nowtime:::::', nowtime);
    if (
      parseInt(this.showtimelist.showysstr) < nowtime &&
      parseInt(this.showtimelist.showysend) > nowtime
    ) {
      this.inway = 1;
    }
    if (
      parseInt(this.showtimelist.showcsstr) < nowtime &&
      parseInt(this.showtimelist.showcsend) > nowtime
    ) {
      this.inway = 2;
    }
    if (
      parseInt(this.showtimelist.showjsstr) < nowtime &&
      parseInt(this.showtimelist.showjsend) > nowtime
    ) {
      this.inway = 3;
    }
  }
  getvotetime() {
    const nowtime = parseInt(new Date().getTime() + '');
    // console.log('nowtime:::::', nowtime);
    if (
      parseInt(this.votetimelist.voteysstr) < nowtime &&
      parseInt(this.votetimelist.voteysend) > nowtime
    ) {
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votecsstr) < nowtime &&
      parseInt(this.votetimelist.votecsend) > nowtime
    ) {
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votejsstr) < nowtime &&
      parseInt(this.votetimelist.votejsend) > nowtime
    ) {
      this.canvote = false;
    }
  }
  async onLoad() {
    this.loading = true;
    // getList(this.page, this.keyword, this.inway + '').then((res: any) => {
    getList(this.page, this.keyword, this.inway + '').then((res: any) => {
      this.endListData(res);
    });
  }
  goback() {
    this.$router.push('index');
  }
  endListData(ret: any) {
    this.page = this.page + 1;
    if (!ret.data || ret.data.length === 0) {
      if (this.list.length <= 0) {
        this.showEmptyimg = true;
      }
      this.finished = true;
    } else {
      this.list = [...this.list, ...ret.data];
      // this.onLoad();
    }
    this.loading = false;
  }
  resetVoteList() {
    this.keyword = '';
    this.list = [];
    this.finished = false;
    this.showEmptyimg = true;
    this.showempty = false;
    this.page = 1;
  }

  onSearch(data: boolean) {
    if (!this.keyword) {
      Toast('请输入编号或作品名');
      return false;
    }
    this.list = [];
    this.page = 1;
    this.showempty = true;
    this.showEmptyimg = false;
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.onLoad();
    }, 200);
  }
  selectData(data: string, index: number) {
    this.value = data;
    if (index === this.selectIndex) {
      return;
    }
    (this.$refs.search as SearchBar).userInput = '';
    this.keyword = '';
    this.selectIndex = index;
    this.onSearch(false);
  }
  onClear() {
    (this.$refs.search as SearchBar).userInput = '';
    this.resetVoteList();
    // this.onLoad();
    // window.location.reload();
  }
}
